import { isCrowdName } from "./serial-context.js";
import type { ValidationIssue } from "./validation.js";
import type { ScriptV4 } from "../script/v4/types.js";

const ACTION_PRONOUN = /(?:^|[，。！？；：、\s“”"'（(])(他们|她们|它们|其中一人|另一个人|前者|后者|对方|有人|两人|他|她|它)(?!人)/;

/**
 * Production-facing quality checks for the final Script v4 document. Ingest
 * appends these as warnings so source fidelity and model uncertainty remain
 * reviewable without turning a valid extraction into data loss.
 */
export function validateProductionStandard(script: ScriptV4): ValidationIssue[] {
  const warnings: ValidationIssue[] = [];
  const warn = (code: string, path: string, message: string): void => {
    warnings.push({ code, path, message });
  };

  script.actors.forEach((asset, index) => {
    if (isCrowdName(asset.actor_name)) {
      warn("production_crowd_actor", `$.actors[${index}].actor_name`, `${asset.actor_name} is a group speaker, not an actor asset`);
    }
  });

  script.episodes.forEach((episode, episodeIndex) => {
    episode.scenes.forEach((scene, sceneIndex) => {
      const scenePath = `$.episodes[${episodeIndex}].scenes[${sceneIndex}]`;
      if (scene.location === null) {
        warn("production_location_missing", `${scenePath}.location`, "production scene needs one stable location");
      }
      scene.actions.forEach((action, actionIndex) => {
        const actionPath = `${scenePath}.actions[${actionIndex}]`;
        if (action.type === "action") {
          const match = ACTION_PRONOUN.exec(action.content);
          if (match) {
            warn("production_action_pronoun", `${actionPath}.content`, `action uses ambiguous reference ${match[1]}`);
          }
        }
      });
    });
  });

  return warnings;
}
